import { UnitInfo } from "../../../UnitInfo";
import { UnitId } from "../UnitId/UnitId";

export enum UnitActionType {
    UnitHighlight = "UNIT_HIGHLIGHT",
    SetUnitTableWidth = "SetUnitTableWidth",
    RemoveUnitTableWidth = "RemoveUnitTableWidth",
    AddUnit = "ADD_UNIT",
    RemoveUnit = "REMOVE_UNIT",
    UpdateEmptyUnits = "UPDATE_EMPTY_UNITS",
    ShowModalUnit = "ShowModalUnit",
    ReplaceModalUnit = "ReplaceModalUnit",
    CloseModalUnit = "CloseModalUnit",
    InitUnitInfo = "InitUnitInfo",
}

export type UnitAction =
    | {
          type: UnitActionType.UnitHighlight;
          payload: {
              unitId: UnitId;
          };
      }
    | SetUnitTableWidthActionType
    | RemoveUnitTableWidthActionType
    | {
          type: UnitActionType.AddUnit;
          payload: {
              bindingPath: string;
              newInstance: string;
              newIndex?: number;
              unitId: UnitId;
          };
      }
    | {
          type: UnitActionType.RemoveUnit;
          payload: {
              bindingPath: string;
              index: string;
              unitId: UnitId;
          };
      }
    | {
          type: UnitActionType.UpdateEmptyUnits;
          payload: {
              unitId: UnitId;
              empty: boolean;
          };
      }
    | {
          type: UnitActionType.ShowModalUnit;
          payload: {
              targetUnitId: UnitId;
              modalUnitId: UnitId;
          };
      }
    | {
          type: UnitActionType.ReplaceModalUnit;
          payload: {
              currentModalUnitId: UnitId;
              nextModalUnitId: UnitId;
          };
      }
    | {
          type: UnitActionType.CloseModalUnit;
          payload: {
              targetUnitId: UnitId;
          };
      }
    | {
          type: UnitActionType.InitUnitInfo;
          payload: {
              unitInfos: UnitInfo[];
          };
      };

export interface RemoveUnitTableWidthActionType {
    type: UnitActionType.RemoveUnitTableWidth;
    payload: {
        tableId: string;
        unitId: UnitId;
    };
}
export interface SetUnitTableWidthActionType {
    type: UnitActionType.SetUnitTableWidth;
    payload: {
        tableId: string;
        unitId: UnitId;
        width: number;
    };
}
